(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  // Build the table of contents from body headings into both the desktop
  // sticky sidebar and the mobile collapsible, then scroll-spy both.
  (function () {
    var section = document.querySelector('[data-article]');
    if (!section) return;
    var body = section.querySelector('[data-article-body]');
    if (!body) return;

    var toc = section.querySelector('[data-toc]');
    var tocMobile = section.querySelector('[data-toc-mobile]');
    var lists = section.querySelectorAll('[data-toc-list], [data-toc-list-mobile]');
    if (!lists.length) return;

    var headings = body.querySelectorAll('h2, h3');
    if (!headings.length) {
      if (toc) toc.setAttribute('hidden', '');
      if (tocMobile) tocMobile.setAttribute('hidden', '');
      return;
    }

    var used = {};
    function slugify(text) {
      var s = (text || '').toLowerCase().trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
      if (!s) s = 'section';
      if (used[s] != null) { used[s]++; s = s + '-' + used[s]; } else { used[s] = 0; }
      return s;
    }

    var linksById = {}; // id -> [anchor, ...] (one per list)
    headings.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent);
      var isSub = h.tagName === 'H3';
      linksById[h.id] = [];
      lists.forEach(function (list) {
        var li = document.createElement('li');
        li.className = 'article__toc-item' + (isSub ? ' article__toc-item--sub' : '');
        var a = document.createElement('a');
        a.className = 'article__toc-link';
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
        linksById[h.id].push(a);
      });
    });

    if (toc) toc.removeAttribute('hidden');
    if (tocMobile) tocMobile.removeAttribute('hidden');

    // Click on any ToC link → mark it active immediately (don't wait for the
    // scroll observer) and collapse the mobile ToC if the click came from it.
    section.addEventListener('click', function (e) {
      var link = e.target.closest('.article__toc-link');
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      Object.keys(linksById).forEach(function (k) {
        linksById[k].forEach(function (a) { a.classList.remove('is-active'); });
      });
      if (linksById[id]) linksById[id].forEach(function (a) { a.classList.add('is-active'); });
      if (tocMobile && tocMobile.contains(link)) tocMobile.removeAttribute('open');
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            Object.keys(linksById).forEach(function (id) {
              linksById[id].forEach(function (a) { a.classList.remove('is-active'); });
            });
            var active = linksById[e.target.id];
            if (active) active.forEach(function (a) { a.classList.add('is-active'); });
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
      headings.forEach(function (h) { observer.observe(h); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Sticky shadow on scroll */
  const header = document.querySelector('.header');
  if (header) {
    let ticking = false;
    function updateShadow() {
      header.classList.toggle('header--scrolled', window.scrollY > 0);
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateShadow);
        ticking = true;
      }
    }, { passive: true });
  }

  /* The search field is a plain always-on form in row 1 now — the old
     toggle-and-dropdown pair is gone, so there is nothing to wire up here. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* «Learn More» — scroll to whatever section follows the hero. Resolved at click time,
     not at load: the next section differs per template, and on some pages it is injected
     after this script runs. If there is nothing below, scroll by a viewport instead of
     doing nothing, so the button is never dead. */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-hero-scroll]');
    if (!trigger) return;
    event.preventDefault();

    var section = trigger.closest('.shopify-section');
    var next = section && section.nextElementSibling;
    while (next && next.offsetHeight === 0) next = next.nextElementSibling;

    /* scrollIntoView puts the section's top at viewport top — which is UNDER the fixed
       header, so its heading is hidden. Offset by the real header height (the CSS var
       covers both rows on mobile) and scroll by coordinate instead. */
    if (next) {
      var headerPx = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 0;
      var rootSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      var top = next.getBoundingClientRect().top + window.scrollY - headerPx * rootSize;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    } else {
      window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  // Product form — variant matching + quantity selector.
  // Runs once per page load and per section render (Shopify editor reload).
  (function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var dataNode = form.querySelector('[data-variants-json]');
      if (!dataNode) return;
      var variants;
      try {
        variants = JSON.parse(dataNode.textContent);
      } catch (err) {
        console.warn('Product form: variants JSON parse error', err);
        return;
      }

      var variantInput = form.querySelector('[data-variant-id]');
      var submitBtn = form.querySelector('[data-submit-btn]');
      var stickySubmitBtn = document.querySelector('[data-sticky-submit-btn]');
      var stickyPriceEl = document.querySelector('[data-sticky-price]');
      var labelAdd = form.dataset.labelAddToCart || 'Add to Cart';
      var labelOOS = form.dataset.labelOutOfStock || 'Out of stock';
      var labelUnavail = form.dataset.labelUnavailable || 'Unavailable';
      // Quote-only products (made-to-order / custom-quote) are requested via the
      // quote form regardless of stock, so variant chips must stay selectable
      // even when a variant reports available:false. Only gate on stock for
      // dropship_free products that can actually be added to cart.
      var quoteOnly = form.dataset.quoteOnly === 'true';

      // Find variant matching currently selected options across all fieldsets.
      function findSelectedVariant() {
        var selected = [];
        form.querySelectorAll('input[data-option-position]:checked').forEach(function (r) {
          var pos = parseInt(r.dataset.optionPosition, 10) - 1;
          selected[pos] = r.dataset.optionValue;
        });
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        }) || null;
      }

      var priceEl = document.querySelector('[data-price]');
      // Quote modal product card — keep it in sync with the selected variant (title + price +
      // image + the hidden variant inputs the lead carries). Looked up on every call, not once:
      // the form lives in a <template> until the modal's first open (assets/product-quote-modal.js),
      // so at page load none of these exist. The last variant is kept and published as
      // window.bqSyncQuoteCard, which the modal calls right after it builds the form.
      // The inputs are `variant_id` / `variant_title` — until 2026-10-29 this looked for the
      // long-gone `contact[variant_id]`, so every quote went out with the page's initial variant.
      var lastQuoteVariant = null;

      function updateQuoteCard(v) {
        if (!v) return;
        lastQuoteVariant = v;
        var quoteVariantEl = document.querySelector('[data-quote-variant]');
        var quotePriceEl = document.querySelector('[data-quote-price]');
        var quoteImageEl = document.querySelector('[data-quote-image]');
        var quoteVariantInput = document.querySelector('[data-product-quote-modal] input[name="variant_id"]');
        var quoteVariantTitleInput = document.querySelector('[data-product-quote-modal] input[name="variant_title"]');
        if (quotePriceEl) quotePriceEl.textContent = v.price_html;
        if (quoteVariantEl) {
          if (v.title && v.title !== 'Default Title') {
            quoteVariantEl.textContent = v.title;
            quoteVariantEl.removeAttribute('hidden');
          } else {
            quoteVariantEl.setAttribute('hidden', '');
          }
        }
        if (quoteImageEl && v.image_url) {
          quoteImageEl.src = v.image_url;
        }
        if (quoteVariantInput) quoteVariantInput.value = v.id;
        if (quoteVariantTitleInput) quoteVariantTitleInput.value = v.title || '';
      }

      window.bqSyncQuoteCard = function () {
        if (lastQuoteVariant) updateQuoteCard(lastQuoteVariant);
      };

      function updateSubmitForVariant(v) {
        if (!v) {
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = labelUnavail;
          }
          if (stickySubmitBtn) {
            stickySubmitBtn.disabled = true;
            stickySubmitBtn.textContent = labelUnavail;
          }
          return;
        }
        variantInput.value = v.id;
        // Sync quote modal card with selected variant
        updateQuoteCard(v);
        var btnLabel;
        var btnDisabled;
        if (v.available) {
          btnLabel = labelAdd;
          btnDisabled = false;
        } else {
          btnLabel = labelOOS;
          btnDisabled = true;
        }
        if (submitBtn) {
          submitBtn.disabled = btnDisabled;
          submitBtn.textContent = btnLabel;
        }
        if (stickySubmitBtn) {
          stickySubmitBtn.disabled = btnDisabled;
          stickySubmitBtn.textContent = btnLabel;
        }
        // Price update — both main display and sticky pill
        if (priceEl) priceEl.textContent = v.price_html;
        if (stickyPriceEl) stickyPriceEl.textContent = v.price_html;
      }

      function updateSelectedDisplay() {
        form.querySelectorAll('[data-selected-value-display]').forEach(function (el) {
          var pos = parseInt(el.dataset.selectedValueDisplay, 10);
          var radio = form.querySelector('input[data-option-position="' + pos + '"]:checked');
          if (radio) el.textContent = radio.dataset.optionValue;
        });
      }

      function currentSelection() {
        var current = {};
        form.querySelectorAll('input[data-option-position]:checked').forEach(function (r) {
          current[r.dataset.optionPosition] = r.dataset.optionValue;
        });
        return current;
      }

      // Best variant carrying `value` at option `pos`, scored by how many of the other
      // current picks it keeps (earlier options weigh more — they read as the primary axis).
      // Holding the other options fixed is NOT enough: sparse matrices exist where every
      // model has exactly one power, so no single-option neighbour exists and the whole
      // picker locks. Re-resolving the rest keeps every value reachable.
      function resolveVariant(pos, value, current, requireAvailable) {
        var best = null;
        var bestScore = -1;
        variants.forEach(function (v) {
          if (v.options[pos - 1] !== value) return;
          if (requireAvailable && !v.available) return;
          var score = 0;
          v.options.forEach(function (opt, i) {
            if (i + 1 === pos) return;
            if (current[String(i + 1)] === opt) score += 100 - i;
          });
          if (score > bestScore) {
            bestScore = score;
            best = v;
          }
        });
        return best;
      }

      function selectOptionValue(pos, value) {
        form.querySelectorAll('input[data-option-position="' + pos + '"]').forEach(function (r) {
          if (r.dataset.optionValue === value) r.checked = true;
        });
      }

      // A chip is disabled only when no variant carries its value at all — for quote-only
      // products stock is irrelevant, so out-of-stock variants stay selectable for quoting.
      function updateChipAvailability() {
        var current = currentSelection();
        form.querySelectorAll('input[data-option-position]').forEach(function (r) {
          // Don't disable the currently-checked one (would orphan selection state)
          if (r.checked) {
            r.disabled = false;
            return;
          }
          var pos = parseInt(r.dataset.optionPosition, 10);
          r.disabled = !resolveVariant(pos, r.dataset.optionValue, current, !quoteOnly);
        });
      }

      // Picking a value pulls the other options onto the resolved variant, Dawn-style.
      // On a full matrix the resolved variant is the exact combination, so nothing else moves.
      function cascadeSelection(pos, value) {
        var current = currentSelection();
        var target = resolveVariant(pos, value, current, !quoteOnly)
          || resolveVariant(pos, value, current, false);
        if (!target) return;
        target.options.forEach(function (opt, i) {
          if (current[String(i + 1)] !== opt) selectOptionValue(i + 1, opt);
        });
      }

      form.querySelectorAll('input[data-option-position]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          cascadeSelection(parseInt(radio.dataset.optionPosition, 10), radio.dataset.optionValue);
          updateSelectedDisplay();
          updateSubmitForVariant(findSelectedVariant());
          updateChipAvailability();
        });
      });

      updateChipAvailability();

      // Quantity selector
      var qtyInput = form.querySelector('[data-qty-input]');
      var qtyMinus = form.querySelector('[data-qty-minus]');
      var qtyPlus = form.querySelector('[data-qty-plus]');
      if (qtyInput && qtyMinus && qtyPlus) {
        var min = parseInt(qtyInput.min, 10) || 1;

        function clampAndUpdate() {
          var val = parseInt(qtyInput.value, 10);
          if (isNaN(val) || val < min) val = min;
          qtyInput.value = val;
          qtyMinus.disabled = val <= min;
        }

        qtyMinus.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || min;
          qtyInput.value = Math.max(val - 1, min);
          clampAndUpdate();
        });
        qtyPlus.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || min;
          qtyInput.value = val + 1;
          clampAndUpdate();
        });
        qtyInput.addEventListener('change', clampAndUpdate);
        qtyInput.addEventListener('blur', clampAndUpdate);

        clampAndUpdate();
      }

      // Sticky CTA — Add to Cart button delegates to the main form.
      // Using requestSubmit() so the form's submit event fires properly
      // (including the AJAX cart handler below).
      if (stickySubmitBtn) {
        stickySubmitBtn.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      }

      // AJAX add-to-cart — intercept submit, POST to /cart/add.js, refresh
      // header counter via /cart.js, animate button to "✓ Added" for 2.5s.
      // Sticky CTA piggybacks through form.requestSubmit() above.
      var labelAdded = form.dataset.labelAdded || 'Added';
      var labelError = form.dataset.labelError || 'Error';
      var addInFlight = false;

      // Lock button widths to the widest label ("Add to Cart") so swapping
      // text between Add to Cart / ✓ Added / Error / Out of stock / Unavailable
      // doesn't reflow the layout.
      [submitBtn, stickySubmitBtn].forEach(function (b) {
        if (!b || b.dataset.widthLocked === '1') return;
        var rect = b.getBoundingClientRect();
        if (rect.width > 0) {
          b.style.minWidth = Math.ceil(rect.width) + 'px';
          b.dataset.widthLocked = '1';
        }
      });

      function setBtnLabel(label, disabled, errorState) {
        [submitBtn, stickySubmitBtn].forEach(function (b) {
          if (!b) return;
          b.disabled = !!disabled;
          b.textContent = label;
          b.classList.toggle('btn--error', !!errorState);
        });
      }

      function restoreBtnFromVariant() {
        var v = findSelectedVariant();
        if (!v || !v.available) {
          var oosLabel = (v && !v.available) ? labelOOS : labelUnavail;
          setBtnLabel(oosLabel, true, false);
        } else {
          setBtnLabel(labelAdd, false, false);
        }
      }

      // «Add to spec» — the primary action on every product, quote-only or not. It writes one line
      // into the visitor's spec (assets/spec-store.js), which is what /cart shows and what the
      // «Request a quote» form sends us. Nothing here touches the Shopify cart.
      var specBtns = document.querySelectorAll('[data-add-to-spec]');
      var labelSpec = form.dataset.labelSpec || 'Add to spec';
      var labelSpecAdded = form.dataset.labelSpecAdded || '✓ In your spec';
      var specFlashTimer = null;

      // Same width lock as the buy button: swapping to «✓ In your spec» must not reflow the row.
      Array.prototype.forEach.call(specBtns, function (b) {
        if (b.dataset.widthLocked === '1') return;
        var rect = b.getBoundingClientRect();
        if (rect.width > 0) {
          b.style.minWidth = Math.ceil(rect.width) + 'px';
          b.dataset.widthLocked = '1';
        }
      });

      function addToSpec() {
        if (!window.BQSpec) return;
        // A product sold in one shape renders no option radios at all, so there is nothing for
        // findSelectedVariant to match — it IS the only variant, and without this fallback the
        // line went into the spec with no price at all.
        var v = findSelectedVariant() || (variants.length === 1 ? variants[0] : null);
        var qtyInput = form.querySelector('[data-qty-input]');
        var moq = parseInt(form.dataset.moq, 10) || 1;
        var qty = parseInt(qtyInput && qtyInput.value, 10);
        if (isNaN(qty) || qty < moq) qty = moq;

        // A product sold in one shape goes in as itself; one sold in several goes in as the size
        // that is on screen — same rule as the builder, and the same line key, so the two surfaces
        // never end up with two lines for one position.
        var named = v && v.title && v.title !== 'Default Title';

        window.BQSpec.add({
          handle: form.dataset.handle,
          title: form.dataset.title,
          url: form.dataset.url,
          image: (v && v.image_url) || form.dataset.image || null,
          category: form.dataset.category || null,
          customizable: form.dataset.customizable === 'true',
          moq: moq,
          qty: qty,
          variant_id: named ? v.id : null,
          variant_title: named ? v.title : null,
          price: v && typeof v.price === 'number' ? v.price : null,
        });
        window.BQSpec.toast();

        Array.prototype.forEach.call(specBtns, function (b) { b.textContent = labelSpecAdded; });
        window.clearTimeout(specFlashTimer);
        specFlashTimer = window.setTimeout(function () {
          Array.prototype.forEach.call(specBtns, function (b) { b.textContent = labelSpec; });
        }, 2000);
      }

      Array.prototype.forEach.call(specBtns, function (b) {
        b.addEventListener('click', addToSpec);
      });

      // Request-a-quote modal — open/close + AJAX submit logic now lives in
      // assets/product-quote-modal.js (loaded `defer` from the modal snippet).
      // It was moved out of this shared section JS bundle so its
      // submit-interception (preventDefault) can't be disabled by an unrelated
      // fault elsewhere in the bundle — which would let the contact form
      // submit natively and page-redirect to ?contact_posted=true. The
      // variant→quote-card sync below stays here (it only writes the hidden
      // context inputs the modal reads via FormData at submit time).

      // «Buy now» — the whole of direct purchase on this storefront (CJ products only).
      //
      // The cart is no longer a place the visitor ever sees: it is emptied first, so a line left
      // over from an abandoned attempt cannot ride along to checkout, then this variant is added
      // and the browser goes straight to payment. Everything else on the site goes through the
      // spec and a quote — see sections/cart.liquid.
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addInFlight) return;
        addInFlight = true;

        setBtnLabel(labelAdded, true, false);  // optimistic + lock

        var fd = new FormData(form);
        // URLs come from data-attributes — Liquid doesn't render inside
        // section JS blocks, so we can't inline routes.cart_*_url here.
        var cartAddUrl = form.dataset.cartAddUrl || '/cart/add.js';
        var cartClearUrl = (form.dataset.cartUrl || '/cart.js').replace(/\.js$/, '/clear.js');

        fetch(cartClearUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(function () {
            return fetch(cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: fd,
            });
          })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) { throw new Error(data.description || data.message || ('HTTP ' + res.status)); });
            }
            return res.json();
          })
          .then(function () {
            // Leaves the page — the label stays on «✓ Added» until the browser navigates away.
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            console.error('Buy now failed:', err);
            setBtnLabel(labelError, false, true);  // red error state
            window.setTimeout(function () {
              addInFlight = false;
              restoreBtnFromVariant();
            }, 2500);
          });
      });

      // Sticky CTA — scroll-based visibility + desktop bounds-tracking.
      //
      // Visibility rule: show ONLY when main CTA has scrolled ABOVE the sticky
      // header (rect.bottom < headerPx). On page load, CTA is below viewport
      // (rect.bottom is a large positive number) so sticky stays hidden — fixes
      // the "appears immediately on mobile page load" bug.
      //
      // Desktop bounds: sticky is fixed-positioned but confined to the right
      // info column (.product-main__info). We read that column's getBoundingClientRect
      // on scroll/resize and write left + width as inline styles. CSS still owns
      // the top + transform + radius/shadow. On mobile this is bypassed — sticky
      // uses left/right/bottom margins from CSS only.
      var stickyEl = document.querySelector('[data-product-sticky]');
      var ctaRow = form.querySelector('.product-main__cta-row');
      var infoCol = document.querySelector('.product-main__info');
      var mqDesktop = window.matchMedia('(min-width: 768px)');

      if (stickyEl && ctaRow) {
        var headerEl = document.querySelector('header') || document.querySelector('.site-header');

        function updateStickyBounds() {
          if (mqDesktop.matches && infoCol) {
            var r = infoCol.getBoundingClientRect();
            stickyEl.style.left = r.left + 'px';
            stickyEl.style.width = r.width + 'px';
            stickyEl.style.right = '';
          } else {
            // Mobile — let CSS edge margins (left/right/bottom) take over
            stickyEl.style.left = '';
            stickyEl.style.width = '';
            stickyEl.style.right = '';
          }
        }

        var scrollRaf = null;
        function updateStickyVisibility() {
          if (scrollRaf !== null) return;
          scrollRaf = requestAnimationFrame(function () {
            scrollRaf = null;
            var headerPx = headerEl ? headerEl.offsetHeight : 64;
            var rect = ctaRow.getBoundingClientRect();
            // Show only when CTA's bottom edge has scrolled above header bottom.
            // This requires the user to actually scroll past the CTA — page-load
            // state with CTA below viewport keeps sticky hidden.
            var stickyShown = rect.bottom < headerPx;
            stickyEl.classList.toggle('is-visible', stickyShown);
            if (stickyShown) {
              stickyEl.removeAttribute('inert');
              stickyEl.removeAttribute('aria-hidden');
            } else {
              stickyEl.setAttribute('inert', '');
              stickyEl.setAttribute('aria-hidden', 'true');
            }
          });
        }

        window.addEventListener('scroll', updateStickyVisibility, { passive: true });
        window.addEventListener('resize', function () {
          updateStickyBounds();
          updateStickyVisibility();
        });
        if (mqDesktop.addEventListener) {
          mqDesktop.addEventListener('change', function () {
            updateStickyBounds();
            updateStickyVisibility();
          });
        }

        updateStickyBounds();
        updateStickyVisibility();
      }
    });
  })();

  // Product gallery — thumbnails (desktop), swipe carousel + dots (mobile),
  // lightbox, variant → media sync.
  (function initGalleries() {
    var mqMobile = window.matchMedia('(max-width: 767px)');

    // The player is mounted by giving the iframe an address and stopped by taking it away —
    // dropping src is what actually halts a YouTube embed, and a slide that is merely hidden
    // would otherwise keep playing sound the shopper cannot see.
    //
    // `expanded` picks which of the two addresses to mount: the muted, control-less one that
    // starts by itself in the gallery slot, or the full player used inside the lightbox.
    function stopEmbeds(root) {
      if (!root) return;
      root.querySelectorAll('.product-gallery__iframe').forEach(function (frame) {
        if (frame.getAttribute('src')) frame.removeAttribute('src');
      });
    }

    function startEmbeds(root, expanded) {
      if (!root) return;
      root.querySelectorAll('.product-gallery__iframe').forEach(function (frame) {
        var want = expanded ? frame.dataset.fullSrc : frame.dataset.previewSrc;
        if (want && frame.getAttribute('src') !== want) frame.setAttribute('src', want);
      });
    }

    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var slides = Array.from(gallery.querySelectorAll('.product-gallery__slide[data-slide-index]'));
      var thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
      var dots = Array.from(gallery.querySelectorAll('[data-dot-index]'));
      var mainStrip = gallery.querySelector('.product-gallery__main');
      if (slides.length === 0) return;

      function updateThumbDotState(index) {
        thumbs.forEach(function (t) {
          var match = parseInt(t.dataset.thumbIndex, 10) === index;
          if (match) {
            t.setAttribute('aria-current', 'true');
            if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          } else {
            t.removeAttribute('aria-current');
          }
        });
        dots.forEach(function (d) {
          var match = parseInt(d.dataset.dotIndex, 10) === index;
          if (match) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }

      var currentIndex = 0;

      function setActive(index) {
        // Wrap around bounds
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        currentIndex = index;

        if (mqMobile.matches) {
          var slide = slides[index];
          if (slide && mainStrip) {
            mainStrip.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          }
        } else {
          slides.forEach(function (s) {
            var match = parseInt(s.dataset.slideIndex, 10) === index;
            s.hidden = !match;
            if (!match) {
              var v = s.querySelector('video');
              if (v && !v.paused) v.pause();
              stopEmbeds(s);
            }
          });
          startEmbeds(slides[index]);
        }
        if (mqMobile.matches) {
          // Mobile keeps every slide in the DOM (scroll carousel), so tear the player
          // down by index instead of by the hidden attribute.
          slides.forEach(function (s) {
            if (parseInt(s.dataset.slideIndex, 10) !== index) stopEmbeds(s);
          });
          startEmbeds(slides[index]);
        }
        updateThumbDotState(index);
      }

      // Main-slot prev/next arrows (desktop+tablet)
      var navPrev = gallery.querySelector('[data-gallery-prev]');
      var navNext = gallery.querySelector('[data-gallery-next]');
      if (navPrev) navPrev.addEventListener('click', function () { setActive(currentIndex - 1); });
      if (navNext) navNext.addEventListener('click', function () { setActive(currentIndex + 1); });

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          setActive(parseInt(t.dataset.thumbIndex, 10));
        });
      });

      // Initial state — mark first slide's dot/thumb as active and mount its player (no iframe
      // carries an address until it is the visible slide).
      updateThumbDotState(0);
      startEmbeds(slides[0]);

      // Mobile: scroll-based active slide detection.
      // Tracks scrollLeft / clientWidth rounded to nearest integer — works
      // perfectly with scroll-snap (slides always land at integer multiples).
      // Registered unconditionally; only acts when mqMobile matches at scroll time,
      // so it survives viewport rotation / resize without re-wiring.
      if (mainStrip) {
        var scrollRaf = null;
        mainStrip.addEventListener('scroll', function () {
          if (!mqMobile.matches) return;
          if (scrollRaf !== null) return;
          scrollRaf = requestAnimationFrame(function () {
            scrollRaf = null;
            var width = mainStrip.clientWidth;
            if (!width) return;
            var index = Math.round(mainStrip.scrollLeft / width);
            if (index < 0) index = 0;
            if (index >= slides.length) index = slides.length - 1;
            if (index !== currentIndex) {
              currentIndex = index;
              slides.forEach(function (s) {
                if (parseInt(s.dataset.slideIndex, 10) !== index) stopEmbeds(s);
              });
              startEmbeds(slides[index]);
              updateThumbDotState(index);
            }
          });
        }, { passive: true });
      }

      // Connect to product form — switch to variant.featured_media on chip change.
      var form = document.querySelector('[data-product-form]');
      if (form) {
        var dataNode = form.querySelector('[data-variants-json]');
        var variants = [];
        if (dataNode) {
          try { variants = JSON.parse(dataNode.textContent); } catch (err) {}
        }
        form.addEventListener('change', function (e) {
          if (!e.target.matches('input[data-option-position]')) return;
          var selected = {};
          form.querySelectorAll('input[data-option-position]:checked').forEach(function (r) {
            selected[r.dataset.optionPosition] = r.dataset.optionValue;
          });
          var v = variants.find(function (vv) {
            return vv.options.every(function (opt, i) { return opt === selected[String(i + 1)]; });
          });
          if (v && v.featured_media_id) {
            var slide = gallery.querySelector('[data-media-id="' + v.featured_media_id + '"]');
            if (slide) {
              setActive(parseInt(slide.dataset.slideIndex, 10));
            }
          }
        });
      }

      // Lightbox — separate index state from preview; preview syncs only on close.
      // Avoids flickering of the preview slot while user navigates inside lightbox.
      var lightbox = document.querySelector('[data-lightbox]');
      if (!lightbox || typeof lightbox.showModal !== 'function') return;
      var lightboxContent = lightbox.querySelector('[data-lightbox-content]');
      var lightboxIndex = 0;

      function cloneSlide(srcSlide) {
        var clone = srcSlide.cloneNode(true);
        var zoom = clone.querySelector('[data-zoom]');
        if (zoom) zoom.remove();
        // The gallery's copy carries no address (or the muted preview one) — full screen always
        // gets the real player: controls, and sound if the browser allows it.
        startEmbeds(clone, true);
        clone.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(function (n) { n.remove(); });
        clone.removeAttribute('hidden');
        clone.classList.add('product-gallery__lightbox-slide');
        return clone;
      }

      function renderLightbox() {
        if (!lightboxContent) return;
        lightboxContent.innerHTML = '';
        lightboxContent.appendChild(cloneSlide(slides[lightboxIndex]));
      }

      function openLightbox(index) {
        lightboxIndex = index;
        // Whatever was playing behind the modal must stop, or it plays under the backdrop.
        stopEmbeds(gallery);
        renderLightbox();
        lightbox.showModal();
      }

      gallery.querySelectorAll('[data-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openLightbox(parseInt(btn.dataset.zoomIndex, 10));
        });
      });


      // Click on the media itself also opens the lightbox. External video included: its preview
      // player takes no pointer events, so the click lands here and gets the shopper the full
      // player instead of nothing happening.
      gallery
        .querySelectorAll('.product-gallery__main .product-gallery__image, .product-gallery__main .product-gallery__embed')
        .forEach(function (node) {
          node.addEventListener('click', function () {
            var slide = node.closest('[data-slide-index]');
            if (!slide) return;
            openLightbox(parseInt(slide.dataset.slideIndex, 10));
          });
        });

      var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-lightbox-next]');
      var closeBtn = lightbox.querySelector('[data-lightbox-close]');

      // Desktop nav — only updates lightboxIndex and re-renders the single slide
      if (prevBtn) prevBtn.addEventListener('click', function () {
        lightboxIndex = (lightboxIndex - 1 + slides.length) % slides.length;
        renderLightbox();
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        lightboxIndex = (lightboxIndex + 1) % slides.length;
        renderLightbox();
      });
      if (closeBtn) closeBtn.addEventListener('click', function () { lightbox.close(); });

      // Backdrop / empty area click closes lightbox.
      // Close unless click landed on the actual media or a nav button.
      lightbox.addEventListener('click', function (e) {
        if (e.target.matches('img, video, iframe')) return;
        if (e.target.closest('[data-lightbox-close], [data-lightbox-prev], [data-lightbox-next]')) return;
        lightbox.close();
      });

      // Keyboard: ← / → / Esc
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' && prevBtn) { e.preventDefault(); prevBtn.click(); }
        if (e.key === 'ArrowRight' && nextBtn) { e.preventDefault(); nextBtn.click(); }
      });

      // Touch swipe inside lightbox: horizontal → prev / next
      var touchStartX = 0;
      var touchStartY = 0;
      lightboxContent.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });
      lightboxContent.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].screenX - touchStartX;
        var dy = e.changedTouches[0].screenY - touchStartY;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) {
          lightboxIndex = (lightboxIndex + 1) % slides.length;
          renderLightbox();
        } else {
          lightboxIndex = (lightboxIndex - 1 + slides.length) % slides.length;
          renderLightbox();
        }
      }, { passive: true });

      // On close: pause videos, clear content, sync preview to where user landed
      lightbox.addEventListener('close', function () {
        var v = lightboxContent.querySelector('video');
        if (v && !v.paused) v.pause();
        lightboxContent.innerHTML = '';
        // Sync preview to lightbox's final index (single update — no flicker)
        setActive(lightboxIndex);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
